export default "__VITE_ASSET___6WkhE7S__"